import { FloraButton } from '@grupoboticario/flora-react';
import { PersonIcon } from '@grupoboticario/flora-react-icons';
import Cookies from 'js-cookie';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth';

import type { ActionsParams } from '../Actions';

export const GoToProfile = ({ hierarchy }: ActionsParams) => {
  const handleOnClick = () => {
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
    window.location.replace('/perfil');
  };

  return (
    <FloraButton
      autotagging-flora='on'
      data-flora='button'
      data-flora-text='ir-para-o-perfil'
      hierarchy={hierarchy}
      has='iconLeft'
      icon={<PersonIcon size='16' aria-hidden />}
      onClick={handleOnClick}
    >
      <ResponsiveFloraTypography fontWeight='bold'>Ir para o perfil</ResponsiveFloraTypography>
    </FloraButton>
  );
};
